<template>
    <div class="">
        <Cargador></Cargador>
        <Router-view></Router-view>
        <Notificacionlocal></Notificacionlocal>
        <Notificacionglobal></Notificacionglobal>
    </div>
</template>

<script>

    import Notificacionglobal from '@/components/esqueleto/NotificacionGlobal'
    import Notificacionlocal from '@/components/esqueleto/NotificacionLocal'
    import Cargador from '@/components/esqueleto/Cargador'

    export default {

        name:'App',

        data(){
            return{

            }
        },

        components: { Cargador, Notificacionlocal, Notificacionglobal },

        methods:{
 
        },

        computed:{
        
        },

        mounted(){
            this.$nextTick(() => {

            })
        },

        updated(){
            
        },

    }

</script>

<style scoped>

</style>
